<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.settings') }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20 page-content setting-content">
        <div class="section-title mb-3">
          {{
            $t('text.organisation').slice(0, 1) +
              $t('text.organisation')
                .slice(1)
                .toLowerCase()
          }}
        </div>
        <div class="secondary-font mb-15">
          {{ $t('text.please_choose_one_as_the_current_organization') }}
        </div>
        <div>
          <el-radio-group v-model="selectedOrganisation">
            <el-radio
              border
              v-for="organisation in organisations"
              :key="organisation.OrganisationName.OrganisationId"
              :label="organisation.OrganisationName.OrganisationId"
              >{{ organisation.OrganisationName.Name }}</el-radio
            >
          </el-radio-group>
        </div>
        <el-button
          type="success"
          plain
          class="common-btn mt-20"
          :loading="loading"
          @click="switchOrganisation"
          v-if="p('Manage Module.Organisation.Settings.Save')"
          >{{ $t('text.save_preference') }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      selectedOrganisation: this.$store.getters[`user/selecteOrganisationId`]
    }
  },
  computed: {
    organisations() {
      return this.$store.getters[`user/userOwnedOrganisations`]
    }
  },
  methods: {
    switchOrganisation() {
      if (!this.selectedOrganisation) {
        let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
        this.$confirm(
          `<div class='warning-content'>${this.$t(
            'text.please_choose_one_as_the_current_organization'
          )}</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
          `Warning`,
          {
            confirmButtonText: this.$t('text.ok').toUpperCase(),
            confirmButtonClass: 'confirm-btn',
            type: 'warning',
            customClass: 'delete-warning-box',
            showClose: true,
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            showCancelButton: false
          }
        )
        return false
      }
      this.handleSetPermission()
    },
    handleSetPermission() {
      this.loading = true
      let organisation = this.organisations.filter(organisation => {
        return (
          organisation.OrganisationName.OrganisationId ===
          this.selectedOrganisation
        )
      })
      this.$store.dispatch('user/assignPermission', organisation[0])
      window.location.reload()
    }
  }
}
</script>

<style lang="scss">
.setting-content {
  .el-radio.is-bordered {
    display: block;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>
